const rowStyle = (record) => {
  if (record.status === 'pending') return { backgroundColor: '#ffd' }
  if (record.status === 'rejected') return { backgroundColor: '#fdd', opacity: 0.5 }
  return {}
}

export default rowStyle
